import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import { of } from 'rxjs';
import { FormsActionTypes } from '../actions/forms.actions';
import * as formActions from '@core/store/actions/forms.actions';
import { FormsService } from '../services/forms.service';

@Injectable()
export class FormsEffects {
  constructor(private formsService: FormsService, private actions$: Actions) {}

  loadData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FormsActionTypes.LoadFormsData),
      exhaustMap(action => {
        return this.formsService.getForms().pipe(
          map(forms => new formActions.LoadFormsSuccess(forms)),
          catchError(error => of(new formActions.LoadFormsFail(error)))
        );
      })
    );
  });
}
